import urljoin from 'url-join';
import { APP_URL } from '@consts/env';

export const getUrl = (...args: string[]): string => {
  return urljoin(APP_URL, ...args.map((arg) => String(arg)));
};
